import { render, staticRenderFns } from "./GoingPc.vue?vue&type=template&id=1e8ba1a4&scoped=true&"
import script from "./GoingPc.vue?vue&type=script&lang=js&"
export * from "./GoingPc.vue?vue&type=script&lang=js&"
import style0 from "./GoingPc.vue?vue&type=style&index=0&id=1e8ba1a4&prod&lang=css&"
import style1 from "./GoingPc.vue?vue&type=style&index=1&id=1e8ba1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ba1a4",
  null
  
)

export default component.exports